import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Divider, Grid, Paper, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
class OverviewLeadsMobile extends Component {
    state = { } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Overview Leads"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}>
                        <Autocomplete
                            id="free-solo-2-demo"
                            // disableClearable
                            freeSolo 
                            options={this.props.salesList.map((option) => {
                                // console.log("LABEL : ", option);
                                return String(option);
                            })}
                            onChange={(event, newValue) => {
                                // console.log("NEWVALUE : ", event);
                                this.props.handleSalesOnChange(newValue);
                                }} 
                            value={this.props.selectedSales}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Pilih Sales"
                                margin="0"
                                variant="outlined"
                                InputProps={{ ...params.InputProps, type: 'search' }}
                            />
                            )}
                            size='small'
                            {...this.prop}
                        />
                    </Filter>
                    {
                    this.props.contactLeadsDisplay.map((leadGroup, index) => {
                        return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">{leadGroup.salesName}</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.leads.length} leads
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {
                                        leadGroup.leads.map((lead, indexLeads) => {
                                            return (
                                                <Paper elevation={2} sx={{mb: "10px", padding: "10px"}} key={`itemleads-${indexLeads}`}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Label</Typography>
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.label}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Kategori</Typography>
                                                            {/* {lead.label} */}
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.product_category}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={3}>
                                                            <Typography component="span">Leads</Typography>
                                                            {/* {lead.label} */}
                                                        </Grid>
                                                        <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.count_category}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                </Paper>
                                            );
                                        })
                                    }
                                    
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default OverviewLeadsMobile;